import { render, staticRenderFns } from "./AppInstall.vue?vue&type=template&id=3549bb39&"
import script from "./AppInstall.vue?vue&type=script&lang=js&"
export * from "./AppInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports